<template>
    <section class="bg-[#f9f4f4] font-ww-medium">
        <div v-if="showTitle" :style="{ color: colorScheme }"
            class="py-8 text-3xl font-bold text-center md:text-4xl lg:text-4xl xl:text-5xl xl:leading-10 font-ww-bold lg:py-16">
            {{ title }}
        </div>

        <div class="">
            <div class="py-4 text-lg text-center text-white uppercase xl:text-xl" :style="{ background: colorScheme }">
                {{ helpers.getStep(1, FilteredPacks, state.variants, page) }}
            </div>

            <div class="px-4 py-6 mx-auto max-w-screen-xl md:py-12">
                <div class="grid grid-cols-12 gap-x-6 gap-y-8" v-if="Object.keys(state.variants).length > 1">
                    <div v-for="(item, index) in state.variants" :key="index"
                        class="flex flex-col col-span-12 md:col-span-6">

                        <div :style="{ borderColor: state.active.variants == index ? colorScheme : '' }"
                            :class="['relative flex flex-col w-full h-full p-6 text-left bg-white border-2 rounded-sm shadow-lg cursor-pointer']"
                            @click="setType(index)"
                            :data-testid="'step2-choice-'+index">
                            <div class="flex flex-row items-center space-x-3">
                                <div v-if="state.active.variants == index" class="check-circle"
                                    :style="{ background: colorScheme }"></div>
                                <div v-else class="check-circle-empty" :style="{ borderColor: colorScheme }"></div>
                                <h2 class="font-bold h3">{{ item.Name }}</h2>
                            </div>
                            <p class="mt-4 textp">{{ item.Text }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-4 text-lg text-center text-white uppercase xl:text-xl" :style="{ background: colorScheme }">
                {{ helpers.getStep(2, FilteredPacks, state.variants, page) }}
            </div>

            <div class="px-4 py-6 mx-auto md:py-12"
                :class="FilteredPacks.length == 2 ? 'max-w-screen-xl' : 'max-w-screen-2xl'">
                <div v-if="Object.keys(FilteredPacks).length > 1"
                    class="grid grid-cols-12 gap-x-6 gap-y-10 justify-center mx-auto max-w-3xl md:justify-between md:space-y-0 lg:max-w-full">
                    <!-- Item Packs -->
                    <div v-for="(item, index) in FilteredPacks"
                        :style="{ borderColor: state.active.packs == index ? colorScheme : '' }"
                        :class="FilteredPacks.length == 2 ? 'lg:col-span-6' : 'lg:col-span-4'"
                        class="flex relative flex-col col-span-12 p-6 w-full h-full text-center bg-white rounded-sm border-2 shadow-lg cursor-pointer"
                        @click="setPack(index)" :key="index" :data-testid="'step3-choice-'+index">
                        <div class="most-popular" :style="{ background: colorScheme }" v-if="index == 2">MOST POPULAR
                        </div>
                        <div class="grid pb-4">
                            <nuxt-img :src="item.Image.url" alt="product" class="object-contain m-auto lg:h-80 md-max:max-w-52"
                                :width="imageWidth" height="282" format="webp" loading="lazy"
                                sizes="xs:220px sm:250px sm:250px sm:250px sm:250px sm:250px"></nuxt-img>
                        </div>
                        <div class="flex relative flex-col pb-14 h-full">
                            <h2 class="font-bold h2 lg:text-3xl"> {{ item.Name }}</h2>
                            <p class="py-2 h4">{{ getValue(index) }}</p>
                            <p class="py-2 h-full textp">{{ item.Text }}</p>
                            <div class="h-full">
                                <p class="py-1 mt-2 font-bold md:mt-4 h3">{{ item.Price }}</p>
                                <p class="py-1 textp">{{ item.Offer }}</p>
                                <div class="mt-2 lg:h-6" v-if="item.SaleRibbon">
                                    <span class="px-3 py-1 text-xs font-semibold bg-gray-200 rounded-full">
                                        {{ item.SaleRibbon }}
                                    </span>
                                </div>
                                <div class="absolute right-0 left-0 bottom-2 mx-auto sm:bottom-0">
                                    <div v-if="state.active.packs == index" class="check-circle"
                                        :style="{ background: colorScheme }"></div>
                                    <div v-else class="check-circle-empty" :style="{ borderColor: colorScheme }"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button @click="addToCart" data-testid="cta-button"
                        class="bg-[#9e3736] w-full max-w-6xl mx-auto hover:opacity-90 cursor-pointer border-b-4 border-b-[#6D1B1B] mt-6 lg:mt-12 text-white xl:py-8 md:py-6 py-4 rounded-sm text-center lg:text-3xl text-2xl font-bold">
                        TRY IT NOW!
                    </button>
                </div>

                <div class="mx-auto mt-3 max-w-lg">
                    <nuxt-img class="w-full" src="/assets/images/custom-payments.svg" loading="lazy" format="webp"
                        width="999" height="80" alt="custom payments" sizes="sm:320px md:320px lg:320px xl:320px" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    UrlLink: {
        type: String,
        default: 'patriot'
    },
    colorScheme: {
        type: String,
        default: '#32395d'
    },
    title: {
        type: String,
        default: "Valentine’s Bundle"
    },
    showTitle: {
        type: Boolean,
        default: false
    },
    imageWidth: {
        type: Number,
        default: 300
    },

})

defineBuilderComponent({
    friendlyName: 'Swatches Zipify',
    inputs: [
        {
            name: "UrlLink",
            type: "string",
            defaultValue: "patriot",
        },
        {
            name: "colorScheme",
            type: "color",
            defaultValue: "#32395d",
        },
        {
            name: "title",
            type: "string",
            defaultValue: "Valentine’s Bundle",
        },
        {
            name: "showTitle",
            type: "boolean",
            defaultValue: false,
        },
        {
            name: "imageWidth",
            type: "number",
            defaultValue: 300,
        }
    ]
})

// Initialize composables
const {
    state,
    products,
    initializePage,
    FilteredPacks,
    setPack,
    setType,
    runEngine,
    page,
} = useSwatches()

const {
    addToCart,
    handleButtonClick
} = useSwatchesCart(runEngine, state, page)

const helpers = useProductHelpers()

initializePage(props.UrlLink)

const getValue = (index) => {
    if (index === 0) {
        return '(GOOD VALUE)'
    } else if (index === 1) {
        return '(DISCOUNTED - GREAT VALUE)'
    } else if (index === 2) {
        return '(BEST VALUE)'
    }
}
</script>

<style>
.most-popular {
    @apply absolute -top-6 uppercase text-white w-40 text-sm 2xl:text-base p-2.5 rounded-sm mx-auto left-0 right-0;
}

.border-green-500 {
    border-color: #10b981 !important;
}

.check-circle-empty {
    @apply w-7 h-7 bg-white relative inline-block border rounded-[50%] border-solid
}

.check-circle {
    @apply w-7 h-7 relative inline-block rounded-[50%]
}

.check-circle::after {
    @apply content-[''] absolute w-2 h-3.5 -translate-x-2/4 -translate-y-2/4 rotate-45 border-[solid] left-2/4 top-[44%];
    border-width: 0 2px 2px 0;
}
</style>
